import React from 'react';

function WhyChooseUsSection() {
  return (
    <section className="why-choose-us-section">
      {/* Light dotted background element */}
      <div className="why-choose-us-dotted-bg"></div>

      <div className="container why-choose-us-container">
        
        {/* Left Column: Overlapping Images Collage */}
        <div className="why-choose-us-images flex-1 relative min-h-[420px]">
          {/* Top/Back Image (team-moc2) */}
          <div className="why-choose-img-wrapper img-top">
            <img
              src="/assets/images/team-moc2.jpg"
              alt="Digital Solutions Strategy"
              className="why-choose-img"
            />
          </div>

          {/* Bottom/Front Image (team-moc3) */}
          <div className="why-choose-img-wrapper img-bottom">
            <img
              src="/assets/images/team-moc3.jpg"
              alt="Digital Solutions Team"
              className="why-choose-img"
            />
          </div>
        </div>

        {/* Right Column: Content */}
        <div className="why-choose-us-content">
          <div className="why-choose-us-subtitle">
            <span>Why Choose Us</span>
            <span className="subtitle-line"></span>
          </div>

          <h2 className="why-choose-us-title">
            The Winning Formula of Our Digital Solutions
          </h2>

          <p className="why-choose-us-description">
            Our distinct combination of expertise, innovation, and commitment builds unmatched value for your business growth. We deliver quality services that bring you closer to success.
          </p>

          <div className="why-choose-us-stats">
            <div className="stat-item">
              <div className="stat-number">92%</div>
              <div className="stat-label">Proven Global<br />Success Record</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Innovation Driven<br />Approach</div>
            </div>
          </div>

          <a href="/services/" className="btn-explore-services">
            Explore Services
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>

      </div>
    </section>
  );
}

export default WhyChooseUsSection;
